import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { IFormKey, IFormSelectOption } from 'src/app/modules/shared/models/forms';
import { IObjectKey } from 'src/app/modules/shared/models/objects';
import { ESubjectType } from 'src/app/modules/shared/models/policy.model';
import { LoggerService } from 'src/app/services/logger.service';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { IAnagrafica } from '../../../shared/components/ndg-variation/ndg-variation.constants';
import { IIbanObject } from '../../athora.constants';
import { contractor_keys_PF, contractor_keys_PG, contractor_variation_form_keys, contractor_variation_form_validators, subject_form_keys } from './contractor-variation.constants';

@Component({
  selector: 'app-contractor-variation',
  templateUrl: './contractor-variation.component.html',
  styleUrl: './contractor-variation.component.scss'
})
export class ContractorVariationComponent implements OnInit, OnChanges {

  @Input() subjectForm: FormGroup;
  subjectFormKeys: IObjectKey[] = CommonUtils.assign(subject_form_keys);
  @Input() form: FormGroup;
  formKeys: IFormKey[] = CommonUtils.assign(contractor_variation_form_keys);
  @Input() ibanList: IIbanObject[] = [];
  @Input() searchedSubject: IAnagrafica = null;
  @Input() addressForm: FormGroup;
  @Input() isReadOnly: boolean;
  @Input() countriesList: IFormSelectOption[];
  @Input() provincesList: IFormSelectOption[];
  @Input() citiesList: IFormSelectOption[];
  @Output() onContractorSearch = new EventEmitter<string>();
  @Output() onContractorReset = new EventEmitter();
  destroy$ = new Subject();

  ngOnInit(): void {
    this.form.get('addressType').valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        const emailControlKey = this.formKeys.find(key => key.controlName === 'email');
        const isEmail = value === 'email';
        isEmail ? this.addressForm.disable() : this.addressForm.enable();
        const validators = isEmail ? [Validators.required, Validators.email] : null;
        this.form.get('email').setValidators(validators);
        if (emailControlKey) {
          emailControlKey.hidden = !isEmail;
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ibanList'] && changes['ibanList'].currentValue) {
      this.formKeys = CommonUtils.populateIbanOptions(this.formKeys, this.ibanList);
    }
    if (changes['searchedSubject'] && changes['searchedSubject'].currentValue) {
      const shareCapitalKey = this.formKeys.find(key => key.controlName === 'shareCapital');
      if (shareCapitalKey) {
        shareCapitalKey.hidden = !this.isLegalSubject;
        const validators = this.isLegalSubject ? contractor_variation_form_validators['shareCapital'] : null;
        this.form.get('shareCapital').setValidators(validators);
      }
    }
  }

  onSearchClick(): void {
    const ndg = this.subjectForm.get('ndg').value;
    LoggerService.logInfo(this.constructor.name, 'onSearchClick', { ndg });
    if (ndg) {
      this.onContractorSearch.emit(ndg);
    }
  }

  reset(): void {
    LoggerService.logInfo(this.constructor.name, 'reset');
    this.onContractorReset.emit();
  }

  get isLegalSubject(): boolean {
    return this.searchedSubject && this.searchedSubject?.['ns2:naturaGiuridica'] === ESubjectType.PF ? false : true;
  }

  get subjectKeys(): IObjectKey[] {
    if (this.searchedSubject) {
      if (this.isLegalSubject) {
        return contractor_keys_PG;
      } else {
        return contractor_keys_PF;
      }
    }
    return null;
  }

  get subjectName(): string {
    if (this.searchedSubject) {
      if (this.isLegalSubject) {
        return `${this.searchedSubject['ns2:ragioneSocialeRiga1']}${this.searchedSubject['ns2:ragioneSocialeRiga2']}`;
      } else {
        return `${this.searchedSubject['ns2:nome']} ${this.searchedSubject['ns2:cognome']}`;
      }
    }
    return null;
  }

  get hideAddressSection(): boolean {
    return this.form && this.form.get('addressType')?.value !== 'address';
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
